// src/components/brandCustomization/shared/TabNavigation.jsx
import React from 'react';

/**
 * TabNavigation - Navegación de pestañas reutilizable
 */
const TabNavigation = ({ tabs, activeTab, onChange }) => {
    return (
        <div className="border-b border-gray-200 mb-8">
            <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                {tabs.map((tab) => {
                    const IconComponent = tab.icon;
                    return (
                        <button
                            key={tab.id}
                            onClick={() => onChange(tab.id)}
                            className={`
              flex items-center py-4 px-1 border-b-2 font-medium text-sm transition-colors
              ${activeTab === tab.id
                                    ? 'border-blue-500 text-blue-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }
            `}
                        >
                            {IconComponent && (
                                <IconComponent className="mr-2" />
                            )}
                            {tab.label}
                            {tab.count !== undefined && (
                                <span className={`ml-2 py-0.5 px-2 rounded-full text-xs ${activeTab === tab.id ? 'bg-blue-100 text-blue-600' : 'bg-gray-100 text-gray-600'
                                    }`}>
                                    {tab.count}
                                </span>
                            )}
                        </button>
                    );
                })}
            </nav>
        </div>
    );
};

export default TabNavigation;
